<swiper [config]="responsivePartialOverflowConfig"
        (swiper)="onWhyStudySwiper($event)"
        class="w-100 why-swiper"
>
    <ng-template swiperSlide>
        <div class="w-100 h-100 d-flex flex-column">
            <img loading="lazy" src="assets/img/home/study-1.webp" class="img-fluid d-block mx-auto" style="max-height: 100px; position: relative; z-index: 2;" />
            <div class="card shadow-xs rounded flex-grow-1" style="margin-top: -50px;">
                <div class="card-body">
                    <h4 class="text-center mx-auto d-block text-dark font-size-18 mt-50">Believe in yourself,<br />because we do.</h4>
                    <p class="text-center mt-5 font-size-14 text-dark">We see every student as part<br />of the IBTC family.</p>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template swiperSlide>
        <div class="w-100 h-100 d-flex flex-column">
            <img loading="lazy" src="assets/img/home/study-2.webp" class="img-fluid d-block mx-auto" style="max-height: 100px; position: relative; z-index: 2;" />
            <div class="card shadow-xs rounded flex-grow-1" style="margin-top: -50px;">
                <div class="card-body">
                    <h4 class="text-center mx-auto d-block text-dark font-size-18 mt-50">Focus on your studies, we'll take care of the rest.</h4>
                    <p class="text-center mt-5 font-size-14 text-dark">From study plans to registration reminders, we've got you covered.</p>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template swiperSlide>
        <div class="w-100 h-100 d-flex flex-column">
            <img loading="lazy" src="assets/img/home/study-3.webp" class="img-fluid d-block mx-auto" style="max-height: 100px; position: relative; z-index: 2;" />
            <div class="card shadow-xs rounded flex-grow-1" style="margin-top: -50px;">
                <div class="card-body">
                    <h4 class="text-center mx-auto d-block text-dark font-size-18 mt-50">Your pass is<br />our promise</h4>
                    <p class="text-center mt-5 font-size-14 text-dark">Come back for free if<br />you don't.*</p>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template swiperSlide>
        <div class="w-100 h-100 d-flex flex-column">
            <img loading="lazy" src="assets/img/home/study-4.webp" class="img-fluid d-block mx-auto" style="max-height: 100px; position: relative; z-index: 2;" />
            <div class="card shadow-xs rounded flex-grow-1" style="margin-top: -50px;">
                <div class="card-body">
                    <h4 class="text-center mx-auto d-block text-dark font-size-18 mt-50">We're in this<br />together.</h4>
                    <p class="text-center mt-5 font-size-14 text-dark">Learning and growing with every engagement. Without you, there is no us.</p>
                </div>
            </div>
        </div>
    </ng-template>
</swiper>